export const tokensForPurchase = [
  {
    name: "75 Tokens",
    price: 99,
    description: "75 Tokens",
    image: require("../assets/icons/500-tokens.png"),
    deal: null,
  },
  {
    name: "500 Tokens",
    price: 499,
    description: "500 Tokens",
    image: require("../assets/icons/1000-tokens.png"),
    deal: null,
  },
  {
    name: "1000 Tokens",
    price: 999,
    description: "1000 Tokens",
    image: require("../assets/icons/2000-tokens.png"),
    deal: null,
  },
  {
    name: "2000 Tokens",
    price: 1999,
    description: "2000 Tokens",
    image: require("../assets/icons/2500-tokens.png"),
    deal: null,
  },
  {
    name: "2500 Tokens",
    price: 2399,
    description: "2500 Tokens",
    image: require("../assets/icons/2500-tokens.png"),
    deal: null,
  },
  {
    name: "5000 Tokens",
    price: 4499,
    description: "5000 Tokens",
    image: require("../assets/icons/5000-tokens.png"),
    deal: 0.8,
  },
  {
    name: "10000 Tokens",
    price: 8499,
    description: "10000 Tokens",
    image: require("../assets/icons/10000-tokens.png"),
    deal: 0.75,
  },
];

export const tokenProducts = tokensForPurchase.filter((p) =>
  String(p?.name || "").toLowerCase().includes("token")
);

export const getTokenProductAmount = (product) => {
  const match = String(product?.name || "").match(/\d+/);
  return match ? Number(match[0]) : 0;
};

export const normalizeTokenProductForCart = (product) => ({
  type: "tokens",
  id: product.name,
  name: product.name,
  image: product.image,
  priceUSD: Number(product.price),
  qty: 1,
  meta: { amount: getTokenProductAmount(product) },
});
